<template>
  <div class="presentation-slideshow">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(image, index) in images" :key="index">
        <img :src="image" alt="" class="slide-image" />
      </swiper-slide>
      <!-- Навигационные кнопки -->
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <!-- Пагинация -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- Кнопка для полноэкранного режима -->
    <button @click="toggleFullScreen" class="fullscreen-button">
      {{ isFullScreen ? 'Exit' :  'Fullscreen' }}
    </button>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'PresentationSlideshow',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      images: [],
      isFullScreen: false,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // Отключаем автоплей для ручного управления
        autoplay: false,
        // Включаем возможность масштабирования (по желанию)
        zoom: true
      }
    }
  },
  created() {
    const slideCount = 59
    const slides = []
    for (let i = 0; i <= slideCount; i++) {
      slides.push(`/slides/Full_En-images-${i}.jpg`)
    }
    this.images = slides
  },
  methods: {
    toggleFullScreen() {
      const elem = this.$el
      if (!document.fullscreenElement) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen()
        }
        this.isFullScreen = true
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
        this.isFullScreen = false
      }
    }
  }
}
</script>

<style scoped>
.presentation-slideshow {
  position: relative;
  width: 100%;
  height: 90vh; /* Заполняем весь экран */
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.fullscreen-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
}

.fullscreen-button:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

/* Адаптация для мобильных устройств */
@media (max-width: 768px) {
  .presentation-slideshow {
    height: 100%;
  }

  .fullscreen-button {
    top: 5px;
    right: 5px;
    padding: 8px;
  }
}
</style>
